import { Modal } from "flowbite-react";
import React, { useRef, useState } from "react";
import cross from "../assets/images/cross.png";
import Email_Icon from "../assets/images/Email_Icon.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Recovery from "../components/account/Recovery";
import UserRecovery from "./userRecovery";

const UserVerifyEmail = (props) => {
  const {
    openModal,
    setOpenModal,
    openRecoveryModal,
    setOpenRecoveryModal,
    openResetPasswordModal,
    setOpenResetPasswordModal,
  } = props;
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const emailref = useRef(null);

  const handlechange = (e) => {
    setError("");
    setEmail(e.target.value);
  };

  const handleforgetpassword = async () => {
    axios
      .post("https://aipricingtool-python.onrender.com/forgot_password", {
        email: email,
      })
      .then((response) => {
        console.log(response.data);
        toast.success("OTP Send To Your Email");
        setOpenRecoveryModal(true);
      })
      .catch((error) => {
        console.log(error);
        setError("Email Does Not Exist Try To Signup?");
      });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleforgetpassword();
    }
  };

  if (error) {
    emailref.current.focus();
  }

  return (
    <>
      <Modal
        show={openModal}
        onClose={() => setOpenModal(false)}
        className="dashboard-modal bg-opacity-60 font-userFont text-[#E3D0A8]"
        size="2xl"
      >
        <Modal.Body className="large">
          <div className="">
            <div className="sign_up px-5 md:px-0 flex justify-center items-center md:items-stretch lg:items-center  flex-col md:flex-row 2xl:py-[20px] ">
              <div className="sign_up_right_modal rounded-3xl w-full">
                <div className="cross w-full flex justify-end cursor-pointer">
                  <img
                    onClick={() => setOpenModal(false)}
                    color="#E3D0A8"
                    src={cross}
                    alt=""
                  />
                </div>
                <div className="max-w-[342px] m-auto text-center md:h-auto mb-5 lg:mb-6  2xl:mb-[68px]">
                  <h1 className="text-[27px] Campton-light pb-[18px]">
                    Forget Your Password?
                  </h1>
                  <p className="text-black ">
                    Don’t worry, happen ta all of us. Enter your email below to
                    recover your password
                  </p>
                </div>
                <div className="form-container flex flex-col  md:gap-4 2xl:gap-8  ">
                  <div className="max-w-[100%] m-auto text-center">
                    <h1 className="text-lg Campton-light mb-4">
                      Enter Your Email
                    </h1>
                    <div className="input items-center flex gap-3 border-2 !border-[#E3D0A8] rounded-xl p-2 md:p-3  2xl:p-[22px] ">
                      <img
                        className="w-4 h-4 md:h-auto md:w-auto"
                        src={Email_Icon}
                        alt=""
                      />
                      <input
                        className="!border-none text-black  !focus:outline-none border p-0  focus:ring-0 w-full placeholder:text-[#E3D0A8] text-2xl placeholder:text-2xl "
                        type="text"
                        placeholder="Email or Username"
                        value={email}
                        ref={emailref}
                        onChange={(e) => handlechange(e)}
                        onKeyDown={(e) => handleKeyDown(e)}
                      />
                    </div>
                    {error && (
                      <>
                        <div onClick={() => navigate("/signup")}>
                          <p className="text-[#ff6839]  text-sm mt-3 cursor-pointer hover:underline hover:underline-offset-2">
                            {error}
                          </p>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="mt-[42px]">
                    <div
                      onClick={() => handleforgetpassword()}
                      className={`bg-[#E3D0A8] text-center px-4 py-2.5 text-white hover:bg-white hover:!text-[#E3D0A8] ease-in-out duration-300 hover:!border hover:!border-[#E3D0A8] `}
                      >
                      Continue
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {openRecoveryModal && (
        <UserRecovery
          openModal={openModal}
          setOpenModal={setOpenModal}
          openRecoveryModal={openRecoveryModal}
          setOpenRecoveryModal={setOpenRecoveryModal}
          openResetPasswordModal={openResetPasswordModal}
          setOpenResetPasswordModal={setOpenResetPasswordModal}
          email={email}
        />
      )}
    </>
  );
};

export default UserVerifyEmail;
